import { Request } from '@/core'
import { auth } from '@/constants/urls'

export default {
  auth(data) {
    return Request.post(auth.auth, data)
  },
  login(data) {
    return Request.post(auth.login, data)
  },
}
